import { EmployeeExtended } from '@pxtra-client-lib-legacy/gen';

export const supportEmail = 'cm@pxtra.de';
export const supportPhone = '+49 381 76873136';

export const link = {
  privacy_policy: 'https://pxtra.de/datenschutz-plattform',
  customer_agb: 'https://pxtra.de/agb-kunden',
  employee_agb: 'https://pxtra.de/agb-mitarbeiter',
  imprint: 'https://pxtra.de/impressum',
  support: 'https://support.pxtra.de/platform',
  contact: 'https://pxtra.de/kontakt',
  consent_declaration: 'https://pxtra.de/einwilligungserklaerung',
  playstore: 'https://play.google.com/store/apps/details?id=de.pxtra.app',
  appstore: 'https://apps.apple.com/de/app/pxtra/id6443715330'
};
export type EmployeeRoutes = keyof Omit<
  EmployeeExtended,
  | 'id'
  | 'status'
  | 'user'
  | 'company'
  | 'groups'
  | 'has_notifications'
  | 'hris_id'
  | 'delayed_deactivation_date'
  | 'deactivation_email_sent'
  | 'personio_id'
  | 'upcoming_benefit_sets'
  | 'next_month_benefit_set'
>;
export const employeeRoutes: Record<EmployeeRoutes, string> = {
  general_data: '/data/personal',
  address: '/data/address',
  contact_data: '/data/contact',
  tax_data: '/data/tax',
  position_data: '/data/position',
  benefit_budget: '/benefits/budget',
  benefit_settings: '/benefits/overview',
  app_settings: '/settings/roles',
  department: '/data/position',
  location: '/data/position',
  cost_center: '/data/position',
  paychex_employee_id: '/data/position',
  custom_fields: ''
};
